import { defineStore } from 'pinia'
import { ref } from 'vue'
import { WebApp } from '@grammyjs/web-app'

export const useLayout = defineStore('layout', () => {
	const addCaseModal = ref(false)
	const bottomNavbar = ref(false)
	const topNavbar = ref(true)

	const hideBottomNavbar = () => {
		bottomNavbar.value = false
		WebApp.setBottomBarColor('#0a0a0a')
	}

	const showBottomNavbar = () => {
		bottomNavbar.value = true
		WebApp.setBottomBarColor('#141414')
	}

	const hideTopNavbar = () => {
		topNavbar.value = false
	}

	const showTopNavbar = () => {
		topNavbar.value = true
	}

	const depositModal = ref(false)
	const depositModalCoinsPrefill = ref(0)
	const depositModalMethod = ref<
		'ton_tether' | 'ton' | 'cryptobot' | 'stars' | undefined
	>(undefined)

	const hideDepositModal = () => {
		depositModal.value = false
		depositModalMethod.value = undefined
	}

	const showDepositModal = (
		prefill?: number,
		method?: 'ton_tether' | 'ton' | 'cryptobot' | 'stars'
	) => {
		if (prefill) {
			depositModalCoinsPrefill.value = prefill
		}
		if (method) {
			depositModalMethod.value = method
		}

		depositModal.value = true
	}

	const openAddCaseModal = () => {
		addCaseModal.value = true
	}

	const activateModal = ref(false)
	const openActivateModal = () => {
		if (localStorage.getItem('activateModalShown')) {
			return
		}

		activateModal.value = true
	}

	const fairInfoModal = ref(false)
	const fairInfoTab = ref(0)
	const openFairInfoModal = (tab = 0) => {
		fairInfoTab.value = tab
		fairInfoModal.value = true
	}

	return {
		bottomNavbar,
		hideBottomNavbar,
		showBottomNavbar,

		addCaseModal,
		openAddCaseModal,

		depositModal,
		depositModalMethod,
		depositModalCoinsPrefill,
		hideDepositModal,
		showDepositModal,

		activateModal,
		openActivateModal,

		topNavbar,
		hideTopNavbar,
		showTopNavbar,

		fairInfoModal,
		fairInfoTab,
		openFairInfoModal
	}
})
